<template>
	<v-layout row wrap class="reps">
		<v-flex xs12>
			<documents-display-toolbar
				:manager="true"
				:sortable="false"
				@sort="filterAndSort"
				@filter="filterAndSort"
				title="REPS"
			></documents-display-toolbar>

			<documents-table :filters="filters" :manager="true"></documents-table>
		</v-flex>
	</v-layout>
</template>

<script>
import DocumentsDisplayToolbar from "@components/partials/DocumentsDisplayToolbar";
import DocumentsTable from "@components/partials/DocumentsTable";
import { mapGetters, mapActions } from "vuex";

export default {
	data() {
		return {
			filters: null,
			usersDocs: null
		};
	},

	components: { DocumentsDisplayToolbar, DocumentsTable },

	computed: {
		...mapGetters({
			USERS: "users"
		})
	},

	methods: {
		...mapActions({
			GET_USERS: "getUsers"
		}),

		filterAndSort(params) {
			let filters = {};

			Object.assign(filters, params);
			this.$set(this, "filters", filters);
		}
	},

	created() {
		this.GET_USERS({ manager: true });
	}
};
</script>
